import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Paper, Typography, Chip, Stack, Button } from '@mui/material';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import PageHeader from '../../components/common/PageHeader';
import { loadPortalData } from '../slices/portalSlice';
import { tokens } from '../../theme/theme';
import { downloadPortalReport } from '../services/portalService';

const TYPE_COLOR = {
  Security: tokens.brand.main,
  Vulnerability: tokens.severity.high,
  Compliance: tokens.severity.info,
  Audit: tokens.severity.medium
};

export default function PortalReportsPage() {
  const dispatch = useDispatch();
  const { reports } = useSelector((s) => s.portal);

  useEffect(() => { dispatch(loadPortalData()); }, [dispatch]);

  return (
    <Box>
      <PageHeader
        title="Reports & Compliance"
        subtitle="Download security reports, vulnerability summaries, and compliance attestations"
      />

      <Paper sx={{ p: 1 }}>
        <Stack divider={<Box sx={{ borderBottom: `1px solid ${tokens.border}` }} />}>
          {reports.map((r) => (
            <Box key={r.id} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1.8 }}>
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.4 }}>
                  <Typography sx={{ fontSize: '0.86rem', color: tokens.text.primary, fontWeight: 500 }}>{r.title}</Typography>
                  <Chip
                    label={r.type} size="small"
                    sx={{ color: TYPE_COLOR[r.type], border: `1px solid ${TYPE_COLOR[r.type]}`, backgroundColor: 'transparent' }}
                  />
                </Box>
                <Typography variant="caption" sx={{ color: tokens.text.muted, fontFamily: '"JetBrains Mono", monospace' }}>
                  {r.id} · {r.date} · {r.format}
                </Typography>
              </Box>
              <Button size="small" variant="outlined" startIcon={<DownloadRoundedIcon fontSize="small" />} onClick={() => downloadPortalReport(r)}>
                Download
              </Button>
            </Box>
          ))}
        </Stack>
      </Paper>
    </Box>
  );
}
